import React, { useEffect, useRef, useState } from "react";
import { Button, NumberKeyboard, PasscodeInput, Swiper } from "antd-mobile";
import logo from "../media/logo2.png"
import Login from "../components/Login";
import Stores from "../components/Stores";
import Workstation from "../components/Workstation";
import { drawError } from "../utils/utils";
import { apiCall } from "../utils/Api";
import Spin from "../components/Spin";
import Cookies from "js-cookie";
export default function Authentication(props) {


    const { globals = {}, setGlobals = () => { }, setWorkStation = () => { } } = props;

    // Has a path
    const path = window.location.pathname;
    const path_id = path.split("/")[1];
    const [pos, setPos] = useState(0);

    const [session, setSession] = useState();
    const [loading, setLoading] = useState(false);

    const ref = useRef();


    const continueToBMO = (_corp_id, _st) => {

        if (globals?.connect) {
            return;
        }

        setLoading(true);
        window.can_call = true;
        apiCall("account/bizToBmo", { store_id: 298, corp_id: _corp_id }, (_s, _r) => {
            if (_s) {
                window.credentials = {
                    socket_url: "wss://" + _r.url + "/ws/",
                    ticket: _r.ticket,
                    store_id: _corp_id,
                    name: _st?.name
                }
                window.history.replaceState(null, '', '/' + _corp_id.toString());
                setGlobals({ ...globals, "connect": true });
                setPos(2)
            } else {
                drawError(_r.error);
            }
            setLoading(false);
        })
    }


    const logout = (_store_id = session.store_id) => {
        setLoading(true);
        apiCall("account/logout", { store_id: _store_id }, (_s, _r) => {
            if (_s) {
                setSession(_r);
                setPos(0)
            } else {
                drawError(_r.error);
            }
            setLoading(false);
        })
    }


    useEffect(() => {
        ref.current?.swipeTo(pos);
    }, [pos, ref])


    const checkSession = () => {



        // Check if saved






        if (session) {
            if (session?.logged_in) {



                // No possible stores
                if (session.available_corps.filter(item => item.can_bmo).length === 0) {
                    drawError("BMO is not currently activated on your account.  Please contact Bookmanager Support to activate.")
                    return;
                }

                // Bypass with path id
                if (path_id && session.available_corps.filter(item => item.can_bmo).find(item => item.id.toString() === path_id.toString())) {
                    let _store = session.available_corps.filter(item => item.can_bmo).find(item => item.id.toString() === path_id.toString()) || { name: "" }
                    continueToBMO(path_id, _store);
                    return;
                }

                // let _saved = Cookies.get("workstation");

                // if (_saved) {
                //     alert("here")
                //     let _split = _saved.split("-");
                //     if (_split.length === 2) {
                //         let _store = session.available_corps.filter(item => item.can_bmo).find(item => item.id.toString() === path_id.toString()) || { name: "" }
                //         continueToBMO(_split[1], _store);
                //     }
                // }



                else {
                    // if (path_id && pos === 1) {
                    //     drawError(<>No store with Bookmanager Online access is linked to this account.<div className="shim" /><div className="shim" /> Contact Bookmanager support for assistance.</>, "Logout", logout)
                    // }
                }

                // If there is only one store, skip store selection
                if (session.available_corps.filter(item => item.can_bmo).length === 1) {
                    let _f = session.available_corps.find(item => item.can_bmo);
                    continueToBMO(_f.id, _f);
                    return;
                }

                // Proceed to store selection
                if (pos !== 2) {
                    setPos(1)
                }



            }
        }

    }

    useEffect(checkSession, [session, pos])



    const drawLogin = () => {
        return <div style={{ "width": "100%" }}><Login globals={globals} setGlobals={setGlobals} setWorkStation={setWorkStation} path_id={path_id} loading={loading} setLoading={setLoading} session={session} setSession={setSession} /></div>
    }

    const drawStoreSelection = () => {
        return (<div style={{ "width": "100%" }}>{(session?.logged_in && <Stores logout={logout} continueToBMO={continueToBMO} session={session} />)}</div>)
    }

    const drawStationSelection = () => {



        return (<div style={{ "width": "100%" }}>{(session?.logged_in && globals.connect && pos === 2 && <Workstation logout={logout} session={session} setWorkStation={setWorkStation} />)}</div>)

    }




    return (
        <Spin loading={loading}>
            <div style={{ "maxHeight": `${window.innerHeight}px` }} >
                <div className="login-wrap" >
                    <div style={{ "height": "50px" }}></div>
                    <img height={50} src={logo} />
                    <div className="shim" />
                    <big><big>BM Reconciliation</big></big>

                    <Swiper indicator={() => <></>} allowTouchMove={false} ref={ref}>
                        <Swiper.Item key={"login"}>
                            {drawLogin()}
                        </Swiper.Item>
                        <Swiper.Item key={"stores"}>
                            {drawStoreSelection()}
                        </Swiper.Item>
                        <Swiper.Item key={"workstation"}>
                            {drawStationSelection()}
                        </Swiper.Item>
                    </Swiper>

                </div>
            </div>
        </Spin>
    )
}